import React, { useState } from "react";
import Dropdown from "../assets/images/icons/arrow-down.svg"; // Import arrow for select
import nextarrow from "../assets/images/icons/next-arrow.svg"; // Consitent with other modals if needed, or just text

const ReportStreamModal = ({ isOpen, onClose, onSubmit, logo, closeIcon }) => {
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason) {
      setError("Please select a reason.");
      return;
    }
    setError("");
    onSubmit({ reason }); // ✅ Only send reason
    // Reset form
    setReason("");
    onClose();
  };

  return (
    <div>
      <div className="get-verified popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md z-50">
        <div className="border-popup bg-white rounded-3xl relative w-full max-w-6xl mx-4 overflow-hidden shadow-2xl">
          {/* Header */}
          <div className="flex justify-between items-start p-10 pb-0">
            {/* Logo Section */}
            <div className="logo-popup flex items-center justify-center">
              <img src={logo} alt="Pipaan Logo" className="w-[150px]" />
            </div>
            {/* Close Button */}
            <button
              onClick={onClose}
              className="hover:opacity-80 transition-opacity"
            >
              <img src={closeIcon} alt="close" className="w-10 h-10" />
            </button>
          </div>

          <div className="p-10 pt-5">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-[#BE1F2E] mb-2">
                Report Live Stream
              </h2>
              <p className="text-sm text-black font-medium">
                Help us understand what's going wrong with this live session.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Reason Dropdown */}
              <div>
                <label className="block text-sm font-bold text-black mb-3">
                  Why are you reporting this live stream?
                </label>
                <div className="relative">
                  <select
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className={`w-full h-14 px-4 rounded-xl border border-[#095228] appearance-none focus:outline-none bg-white cursor-pointer text-sm ${
                      reason === "" ? "text-gray-400" : "text-black"
                    }`}
                  >
                    <option value="" disabled hidden>
                      Select a Reason
                    </option>
                    <option value="Inappropriate Content">
                      Inappropriate Content
                    </option>
                    <option value="Spam or Scam">Spam or Scam</option>
                    <option value="Harassment or Hate Speech">
                      Harassment or Hate Speech
                    </option>
                    <option value="Violence or Dangerous">
                      Violence or Dangerous
                    </option>
                    <option value="Other">Other</option>
                  </select>
                  <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                    <img src={Dropdown} alt="" className="w-4 h-4" />
                  </div>
                </div>
                {error && (
                  <p className="text-red-500 text-xs mt-1 ml-1">{error}</p>
                )}
              </div>

              {/* Description removed as per requirement */}

              {/* Submit Button */}
              <div className="pt-4">
                <button
                  type="submit"
                  className="bg-[#BE1F2E] text-white px-10 h-14 rounded-full hover:bg-red-700 transition shadow-md font-bold text-base"
                >
                  Submit Report
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportStreamModal;
